import React, { useEffect } from 'react';
import cn from 'classnames';
import moment from 'moment';

import Button from 'components/form/Button.component';
import { useTheme } from 'providers/Theme.provider';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import { fromAnyDateToIso } from 'utils/converters/time/from.util';
import logger from 'utils/logger.util';
import isDateWorthy from 'utils/predicates/time/isDateWorthy.util';

import DateRangePicker from 'reports/Common/DateRangePicker';

import CN from './TimeRangeDropDown.module.scss';

const L = logger('TimeRangeDropDown');

const determineDurationExists = ({ bgn, end }) =>
  fromAnyToBool(isDateWorthy(bgn) && isDateWorthy(end) && 0 === moment.duration(moment(bgn).diff(end)).days);

const TimeRangeDropDown = ({ isTimeRange, lastDatesSelected, onDoneSelectTime, setDatePickerDate }) => {
  const { isDarkMode } = useTheme();
  const location = window.location;

  useEffect(() => {
    //
    if (!lastDatesSelected) {
      L.debug('useEffect()', 'No lastDatesSelected:', lastDatesSelected);
      return;
    }

    const bgn = lastDatesSelected?.fromDate;
    const end = lastDatesSelected?.toDate;
    const hasDuration = determineDurationExists({ bgn, end });

    if (!hasDuration) {
      L.debug('useEffect()', 'hasDuration:', hasDuration, 'between', { bgn, end });
      return;
    }

    const bgnWeek = fromAnyDateToIso(moment(bgn).startOf('week'));
    const endWeek = fromAnyDateToIso(moment(bgn).endOf('week'));

    L.debug('useEffect()', 'calling setDatePickerDate() with', bgnWeek, endWeek, { bgn, end, bgnWeek, endWeek });

    setDatePickerDate(bgnWeek, endWeek);
    //
  }, [lastDatesSelected, setDatePickerDate]);

  L.debug('useEffect()', { lastDatesSelected });

  return (
    <div
      data-bem="TimeRangeDropDown"
      className={cn({
        'dd-time-range': isTimeRange,
        'dd-time-range hidden': !isTimeRange,
        [CN.component]: true,
        [CN.darkMode]: isDarkMode,
      })}
    >
      <div className={CN.header}>
        <div>Only show clients whose last visit and next visit is between two dates</div>
        <div className={CN.buttonContainer}>
          <Button variant="primaryForce" onClick={onDoneSelectTime}>
            DONE
          </Button>
        </div>
      </div>

      <DateRangePicker
        tag="TimeRangeDropDown__range-picker"
        onChangeDate={setDatePickerDate}
        lastDatesSelected={lastDatesSelected}
        location={location}
        isFetching={false}
      />
    </div>
  );
};

export default TimeRangeDropDown;
